module.exports = __webpack_public_path__ + "static/media/M1-26-Halfdan-Galadris-Ev-cod135.ea28d12f.png";